import { MessagesProvider } from './contexts/MessagesContext';
import { NarrativePage } from './NarrativePage';

export const NarrativePageWrapper = ({ isShare = false }) => {
  return (
    <MessagesProvider isShare={isShare}>
      <NarrativePage isShare={isShare} />
    </MessagesProvider>
  )
}